import React, { useEffect, useState } from "react";
import { useStore } from "../../helpers";
import { observer } from "mobx-react-lite";
import { VoterCard } from "./Voters";
import { useTranslation } from "react-i18next";
import { EditVoter } from "./edit-voter";
import {
    DownLoadVoterData,
    FilterOverLay,
    SearchVoterList,
} from "../voter-list";
import { LoadingState, SideOverlay } from "../../components";
import { useGetFullProject } from "../../custom-hooks";
import { useNavigate, useParams } from "react-router";
import { Masonry } from "@mui/lab";

import ManageVotersTableView from "./manage-voters-table-view";
import { VoterEligibilityCheck } from "./voter-eligibility-check";

import { EligibleSchemesView } from "./Eligible-schemes-view";
import { FTPBreadCrumbs } from "../../components-new";
import PageShell from "../../layouts/PageShell";

export const ManageVoters = observer(() => {
    const rootStore = useStore();
    const [isTableView, setIsTableView] = useState(false);
    const { voterListStore } = rootStore;
    const { FilterStatus, Voterlist } = voterListStore;
    const { edit_voter_modal } = voterListStore;
    const { t } = useTranslation("manage_voters");
    const { isLoading } = useGetFullProject();
    const { projectid } = useParams();
    const navigate = useNavigate();
    const { scheme_info, voter_eligible_schemes, scheme_eligibilty_criteria } =
        voterListStore;

    const close_Filter_modal = () => {
        voterListStore.setFilterStatus(false);
        voterListStore.setShowVoterlist(true);
        voterListStore.setFilterVal(null);
        voterListStore.setSelectedBooths([]);
    };

    useEffect(() => {
        return () => voterListStore.reset_filters(parseInt(projectid));
    }, []);

    const crumbs = [
        { name: "DashBoard", href: `/project/${projectid}`, current: true },
        { name: "Manage Voters", href: "#", current: true },
    ];

    if (isLoading) return <LoadingState />;

    const Actions = (
        <div className="flex items-center justify-between sm:justify-end">
            <button
                className="rounded-[10px] bg-black px-3 py-2 text-sm font-bold text-white sm:rounded-xl sm:text-base md:px-3 md:py-3"
                onClick={() =>
                    // navigate(`/project/${projectid}/manage-voters/tableview`)
                    setIsTableView(!isTableView)
                }
            >
                Switch to {isTableView ? "Card View" : "Table View"}
            </button>
            <DownLoadVoterData voterData={Voterlist} cols={[]} />
        </div>
    );

    return (
        <>
            <PageShell
                title="Manage Voters"
                breadcrumbs={<FTPBreadCrumbs crumbs={crumbs} />}
                headerActions={Actions}
            >
                <SearchVoterList isManage={true} user={true} />
                {!isTableView ? (
                    <Masonry
                        columns={{ sm: 1, md: 2, lg: 3, xl: 4 }}
                        spacing={4}
                        sequential
                    >
                        {Voterlist?.map((data, index) => (
                            <div key={index} className="w-full">
                                <VoterCard voterdata={data} />
                            </div>
                        ))}
                    </Masonry>
                ) : (
                    <ManageVotersTableView />
                )}
            </PageShell>

            <SideOverlay
                children={<FilterOverLay />}
                onClose={close_Filter_modal}
                show={FilterStatus}
                title={t("filter_votersearch")}
                buttontitle={"Apply Filters"}
                size={"large"}
            />

            <SideOverlay
                onClose={() =>
                    voterListStore.update_edit_voter_modal(!edit_voter_modal)
                }
                show={edit_voter_modal}
                children={<EditVoter />}
                title={"Edit Voter"}
            />
            <SideOverlay
                onClose={() => {
                    voterListStore.update_info_scheme(false);
                    // voterListStore.update_voter_eligible_schemes(true);
                }}
                show={scheme_info}
                children={<VoterEligibilityCheck />}
                title={"Eligibilty Check"}
            />
            <SideOverlay
                onClose={() =>
                    voterListStore.update_voter_eligible_schemes(false)
                }
                show={voter_eligible_schemes}
                children={<EligibleSchemesView />}
                title={"Applicable Schemes"}
                size={"large"}
            />
        </>
    );
});

export default ManageVoters;
